import { usePath } from '@cast/utils';

import { PRODUCT_BASE_PATHS } from '@cast/console-constants';
import { useOrganizations } from '@cast/shared-organization-context-data-access';
import {
  RADAR_NAV_TITLE,
  useShouldLimitConsoleForReporting,
} from '@cast/shared-trial-ui';
import {
  makeOrgCostMonitoringAllocationGroupsLink,
  makeOrgCostMonitoringClustersLink,
  makeOrgCostMonitoringNodeTemplatesLink,
} from 'features/organization/cost-report/links';

import { SidebarItem } from '../../_components/SidebarItem';

export const CostMonitoringOrgSidebarItems = () => {
  const { currentOrganization } = useOrganizations();
  const limitAutomationConsole = useShouldLimitConsoleForReporting();
  const basePath = PRODUCT_BASE_PATHS.automation;
  const rulesConditions = { organizationId: currentOrganization?.id };
  const clustersCostMonitoringLink = usePath(() =>
    makeOrgCostMonitoringClustersLink()
  );

  const allocationGroupsCostMonitoringLink = usePath(() =>
    makeOrgCostMonitoringAllocationGroupsLink()
  );

  const nodeTemplatesCostMonitoringLink = usePath(() =>
    makeOrgCostMonitoringNodeTemplatesLink()
  );

  return (
    <>
      <SidebarItem
        title={RADAR_NAV_TITLE}
        testId="org-cost-monitoring"
        url={`${basePath}/cost-report`}
      >
        <SidebarItem
          title="Clusters"
          url={clustersCostMonitoringLink}
          rules={[['view', 'OrganizationCostMonitoring']]}
          rulesConditions={rulesConditions}
          allowedInReadOnlyOrg
        />
        <SidebarItem
          title="Allocation groups"
          url={allocationGroupsCostMonitoringLink}
          rules={[['view', 'OrganizationCostMonitoring']]}
          rulesConditions={rulesConditions}
        />
        <SidebarItem
          title="Idle Resources"
          url={`${basePath}/cost-report/idle-resources`}
          supportsDemo={false}
          rules={[['view', 'OrganizationCostMonitoring']]}
          rulesConditions={rulesConditions}
        />
        {!limitAutomationConsole && (
          <SidebarItem
            title="Resource efficiency"
            url={nodeTemplatesCostMonitoringLink}
            rules={[['view', 'OrganizationCostMonitoringNodeTemplates']]}
            rulesConditions={rulesConditions}
          />
        )}
        {!limitAutomationConsole && (
          <SidebarItem
            title="Savings report"
            url={`${basePath}/cost-report/savings-report`}
            supportsDemo={false}
            rules={[['view', 'ValueReport']]}
            rulesConditions={rulesConditions}
          />
        )}
        {!limitAutomationConsole && (
          <SidebarItem
            title="Custom dashboards"
            testId="org-custom-dashboards"
            url={`${basePath}/cost-report/dashboards`}
            rules={[['view', 'OrganizationCustomDashboards']]}
            rulesConditions={rulesConditions}
          />
        )}
      </SidebarItem>

      {!limitAutomationConsole && (
        <SidebarItem
          title="Network Intelligence"
          url={`${basePath}/network-intelligence`}
          rules={[['view', 'OrganizationNetworkIntelligence']]}
          rulesConditions={rulesConditions}
        />
      )}

      <SidebarItem
        title="Budgets"
        testId="org-budgets"
        url={`${basePath}/budgets`}
        rules={[['view', 'OrganizationBudgets']]}
      />
    </>
  );
};
